import $ from 'jquery';
import {noValue} from './StringColumn';
import Select2BaseColumn from './Select2BaseColumn';
import {odata} from 'linksoft';
const log = require('debug')('linksoft:datatables:LookupColumn');

export default class LookupColumn extends Select2BaseColumn {

	get multiSelect () {
		return !!this.options.isArray;
	}

	get orderByProp() {
		return this.sourceProp + '.name';
	}

	displayValue(value) {
		const output = this.multiSelect
				? (value || []).map(v => this.getLookupName(v)).join(', ')
				: this.getLookupName(value);
		return output || noValue;
	}

	getLookupName(value) {
		return value && value.name || value;
	}

	getCustomFilter() {
		return this.options && this.options.select2Filter;
	}
	
	getFilterValue() {
		const $target = this.column.filter().find('.table-filter');
		const {id, text} = $target.select2('data')[0] || {};
		return id ? JSON.stringify({id, name: text}) : '';
	}
	
	setFilterValue(value) {
		const item = JSON.parse(value || '{}');
		this.getSelect2Filter().val(item.id || '').trigger('change');
	}

	createEditor(value, id) {
		const {dataUrl} = this.options;
		const customFilter = this.getCustomFilter();
		if (!dataUrl) {
			log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
			return null;
		}
		const selected = (this.multiSelect ? value : [value]).map(item => this.getSelectedOption(item));
		const multi = this.multiSelect ? ` multiple="multiple" ` : '';
		return (
			`<select class="form-control table-input" 
                    data-ajax--url="${dataUrl}" 
                    data-odata="true"
                    ${customFilter ? `data-odata-filter="${customFilter}"` : ''}
                    data-allow-clear="true" 
                    data-width="resolve" ${multi}
                    data-placeholder="${this.api.i18n('Select2Placeholder', 'Choose...')}">${selected}</select>`
		);
	}

	getSelectedOption(item) {
		return item ? `<option selected="selected" value="${item.id}">${item.name}</option>` : ''
	}

	getEditorValue(cellElement) {
		const $el = $(cellElement).find('.table-input');
		const value = $el.val() || (this.multiSelect ? [] : null);
		if(this.multiSelect) {
			return (value || []).map(v => this.getItemById($el, v)).filter(v => v);
		}
		return this.getItemById($el, value);
	}

	getItemById($select, value) {
 	  const id = parseInt(value, 10);
 	  if(isNaN(id)) return null;
 	  const name = $select.find(`option[value='${id}']`).text();
		return {id: id, name: name};
	}

	// -------------- FILTERS --------------------


	createFilter() {
		const {dataUrl} = this.options;
		const customFilter = this.getCustomFilter();
		const filterValue = this.api.column(this.index).search();
		const item = JSON.parse(filterValue || 'null');
		const options = this.getSelectedOption(item);
		if (!dataUrl) {
			log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
			return null;
		}
		

		return (
`<div class="input-group">
	<select class="form-control table-filter"
					data-ajax--url="${dataUrl}"
					${customFilter ? `data-odata-filter="${customFilter}"` : ''}
					data-odata="true"
					data-width="resolve"
					data-placeholder="${this.api.i18n('Select2Placeholder', 'Choose...')}">${options}</select></div>`
		);
	}

	buildFilterExpression(fieldName, columnFilter) {
		const value = parseInt(JSON.parse(columnFilter).id);
		return this.options.isArray
				? odata.filters.anyEquals(fieldName, value, 'id')
				: odata.filters.equals(fieldName, value, 'id');
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/LookupColumn.js